import { createActionTypes } from "@helpers/redux-helpers";

export const getPostDetailsActionTypes = createActionTypes("postDetails/get");

export const setCommentsCountActionTypes = "countComments/set";

export const setSibilingsActionType = "postDetails/setSibilings";
